module.exports = __webpack_public_path__ + "img/TAG-min.edd83b0d.png";